import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { TermsNetflixComponent } from '../../../netflix/components/terms-netflix/terms-netflix.component';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Service } from '../../../services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-netflix-subs',
  templateUrl: './netflix-subs.component.html',
  styleUrls: ['./netflix-subs.component.sass']
})
export class NetflixSubsComponent implements OnInit {
  public tabActive = 'Pagos y Facturas';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token: string = sessionStorage.getItem("token");
  forgotForm: FormGroup;
  public accountList2;
  public inicio = true;
  public subscriberCounter = 0;
  public accountSel = "";
  public subscriberSel = "";
  public offers: Array<any>;
  public sw1 = true;
  public sw2 = false;
  public viewNetflixPeperless = false;
  public expand = [];
  public screen = 1;
  public checkNetflix;
  public validationScreen: string = 'sendCode';

  constructor(private router: Router,private formBuilder: FormBuilder, public global: GlobalService, private services: Service, private loadingScreenService: LoadingScreenService, public dialog: MatDialog) { }

  ngOnInit() {
    this.global.validateSession();
    this.forgotForm = this.formBuilder.group({
      code: ['', Validators.required]
    });

  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }

  ngAfterContentInit() {
    if (sessionStorage.getItem("banlist") != undefined && this.accountList2 == null) {
      this.accountList2 = JSON.parse(atob(sessionStorage.getItem("banlist")));
    }
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    if (this.global.sessionReview() == true) {
      this.selectBan = '';
      this.accountDetails(false);
    }
  }
  updateExpand(index) {
    this.global.validateSession();
    this.expand[index] = !this.expand[index];
  }
  accountDetails(index) {
    this.offers = [];
    this.loadingScreenService.startLoading();
    this.services.getAcounts(sessionStorage.getItem("token")).subscribe(data => {
      if (data.hasError == false) {
        this.loadingScreenService.stopLoading();
        this.accountList2 = data.accounts;
        this.accountDetailsLoad(0);
      }
      else {

      }
    });
  }
  accountDetailsLoad(index) {
    if ((parseInt(this.accountList2.length) - 1) == index) {
      this.offers.push(JSON.parse(this.offersData(this.accountList2[index].subscribers, this.accountList2[index].account, this.accountList2[index].paperless)));
      if (this.accountList2[index].paperless == false) {
        this.inicio = false;
      }
      this.loadOffers(this.offers, this.inicio);
    }
    else {
      if (this.accountList2[index].paperless == false) {
        this.inicio = false;
      }
      this.offers.push(JSON.parse(this.offersData(this.accountList2[index].subscribers, this.accountList2[index].account, this.accountList2[index].paperless)));
      this.accountDetailsLoad((index + 1));
    }
  }
  loadOffers(offers, paperless) {
    var cont = 0;
    var ofertas = '{"offers":[';
    for (var i = 0; i < offers.length; i++) {
      if (i > 0) {
        ofertas += ',';
      }
      ofertas += '{"offers":[' + JSON.stringify(offers[i]) + ']}';
      if (offers[i].offers.length > 1) {
        cont = 1;
      }
    }
    ofertas += ']}';
    this.offers = JSON.parse(ofertas);

    if (cont == 1) {
      if (this.offers['offers'][0].offers[0].offers[0].netFlixBlackListed == 'false') {
        this.subscriberSel = this.offers['offers'][0].offers[0].offers[0].subscriber;
        this.accountSel = this.offers['offers'][0].offers[0].ban;
        if (this.offers['offers'].length > 0) {
          this.expand[0] = true;
        }
        this.sw1 = true;
        if (paperless == false) {
          this.viewNetflixPeperless = true;
        }
      }
      else {
        if (this.offers['offers'].length > 0) {
          this.expand[0] = true;
        }
        this.sw1 = true;
      }
    }
    else {
      if (this.offers['offers'][0].offers[0].offers[0].netFlixBlackListed == 'false') {
        this.subscriberSel = this.offers['offers'][0].offers[0].offers[0].subscriber;
        this.accountSel = this.offers['offers'][0].offers[0].ban;
        this.sw1 = false;
        this.sw2 = false;
        if (paperless == false) {
          this.viewNetflixPeperless = true;
        }
      }
      else {
        this.sw1 = false;
        this.sw2 = true;
      }
    }
  }
  activarOpcion(index, subItems, obj) {
    if (this.global.validateSession() === true) {
      this.subscriberSel = "";
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].offers[0].offers.length; j++) {
          if (obj[i].offers[0].offers[j].status != 'S' && obj[i].offers[0].offers[j].netFlixBlackListed == 'false') {
            const ele = document.getElementById("optCheckNetflix_" + i + "_" + j) as HTMLInputElement;
            ele.checked = false;
            //this.checkNetflix[i][j]=false; //new
            if (obj[i].offers[0].offers[j].netFlixBlackListed == true) {
              document.getElementById("optNetflix_" + i + "_" + j).className = "optchoice auto roboto-r text-left on2";
            }
            else {
              document.getElementById("optNetflix_" + i + "_" + j).className = "optchoice auto roboto-r text-left";
            }
          }
        }
      }
      const ele2 = document.getElementById("optCheckNetflix_" + index + "_" + subItems) as HTMLInputElement;
      if (ele2.checked == true) {
        // if(this.checkNetflix[index][subItems]){//new
        ele2.checked = false;
        this.checkNetflix[index][subItems] = false; //new
        this.subscriberSel = "";
        this.accountSel = "";
        document.getElementById("optNetflix_" + index + "_" + subItems).className = "optchoice auto roboto-r text-left";
      }
      else {
        this.subscriberSel = obj[index].offers[0].offers[subItems].subscriber;
        this.accountSel = obj[index].offers[0].ban;
        ele2.checked = true;
        //this.checkNetflix[index][subItems]=true; //new
        document.getElementById("optNetflix_" + index + "_" + subItems).className = "optchoice auto roboto-r text-left on";
      }
    }
  }
  activarNetflixMult(paperless) {
    //alert(this.subscriberSel);
    
    this.global.validateSession();
    if (this.subscriberSel == "") {//revisar
      this.global.notif("Debe selecciona un número de suscriptor para poder agregar el Servicio Netflix.");
    }
    else {
      this.sw1 = false;
      if (paperless == true) {
        this.viewNetflixPeperless = true;
      }
    }
  }
  showterms() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(TermsNetflixComponent, dialogConfig);
  }

  offersData(data, ban, peperless) {
    var status = false;
    var cantidad = 0;
    for (var i = 0; i < data.length; i++) {
      if (data[i].status != "S" && data[i].netFlixBlackListed == 'false') {
        status = true;
        cantidad++;
      }
    }
    this.subscriberCounter = this.subscriberCounter + cantidad
    var ofertas = '{"ban":"' + ban + '","peperless":"' + peperless + '","status":"' + status + '","cantidad":"' + cantidad + '","offers":[';
    for (var i = 0; i < data.length; i++) {
      if (i > 0) {
        ofertas += ',';
      }
      if (data[i].netFlixBlackListed == "") {
        ofertas += '{"subscriber":"' + data[i].subscriber + '","netFlixBlackListed":"false","status":"' + data[i].status + '"}';
      }
      else {
        ofertas += '{"subscriber":"' + data[i].subscriber + '","netFlixBlackListed":"' + data[i].netFlixBlackListed + '","status":"' + data[i].status + '"}';
      }

    }
    ofertas += ']}';
    return ofertas;
  }
  cancel(){
    this.router.navigate(['/netflix']);
  }
  validateCode() {
    this.loadingScreenService.startLoading();
    this.services.validateCode(sessionStorage.getItem("token"),this.forgotForm.controls.code.value).subscribe(data => {
      if (data.hasError == false) {
        this.services.suscribirNeflix(navigator.userAgent,sessionStorage.getItem("token"), this.accountSel, this.subscriberSel).subscribe(data => {
          this.loadingScreenService.stopLoading();
          if (data.hasErrorField == false) {
            window.open(data.urlField, '_self');
          }
          else {
            this.global.notif(data.errorDescField);
          }
        });
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.errorDisplay);
      }
    });
  }
  validTerm() {
    this.global.validateSession();
    if (!this.forgotForm.invalid) {
      var terminos2 = document.getElementById("idTermsAndConditionsNet") as HTMLInputElement;
      var terminos = terminos2.checked;
      if (terminos == true) {
        this.validateCode();
      }
      else {
        this.global.notif('Debe aceptar los Términos y Condiciones para continuar.');
      }
    }
    else {
      this.global.notif("Debe colocar un código valido.");
    }
  }
}
